<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <div :class="sectionClassArray" :style="sectionStyle">
            <mimic-amp-carousel :images="contents.images" :delay="contents.delay"></mimic-amp-carousel>
          </div>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide': isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="スライド画像の選択 （３枚以上）" :label-width="labelWidth">
          <ul class="image-select">
            <template v-for="(image, index) in media">
              <li class="image-select-item" :key="index">
                <input type="checkbox" :id="_uid + '-' + image.id" class="image-select-input" v-model="contents.images" :value="imagesReduced[index]" />
                <label :for="_uid + '-' + image.id" class="image-select-label">
                  <img class="image-select-image" :src="image.source_url">
                </label>
              </li>
            </template>
          </ul>
          <el-button style="margin-top:1em" type="primary" @click="resetImage">リセット</el-button>
        </el-form-item>
        <el-form-item label="１枚あたりの画像表示時間 （ミリ秒）" :label-width="labelWidth">
          <el-input type="number" class="width-75" v-model="contents.delay" auto-complete="off" min="1000"></el-input>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpCarousel from '@/components/mimic-amp/MimicAmpCarousel'

export default {
  name: 'carousel-standard-1',
  components: {
    'mimic-amp-carousel': MimicAmpCarousel
  },
  mixins: [ComponentBase],
  data () {
    return {
      labelWidth: '11em',
      extensions: ['amp-carousel']
    }
  },
  computed: {
    imagesReduced: function () {
      return this.media.map(image => ({
        id: image.id,
        src: image.source_url,
        width: image.media_details.width,
        height: image.media_details.height,
        alt_text: image.alt_text
      }))
    }
  },
  methods: {
    resetImage: function () {
      this.contents.images = []
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      if (contents.images.length === 0) return ''

      let imagesHtml = ''
      contents.images.forEach(image => {
        imagesHtml += `<amp-img width="${image.width}" height="${image.height}" layout="responsive" src="${image.src}" alt="${image.alt_text}" attribution="${this.settings.site.owner} All Rights Reserved."></amp-img>`
      })

      return `
      <div id="${this.sectionId}" class="${this.sectionClass}">
        <amp-carousel width="${contents.images[0].width}" height="${contents.images[0].height}" loop autoplay layout="responsive" type="slides" delay="${contents.delay}" class="theme-base-bg-color">${imagesHtml}</amp-carousel>
      </div>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      return {layout, theme}
    }
  },
  created: function () {
    // migration
    this.contents.images.forEach(image => {
      if (!image.id) image.id = this.media.find(img => img.source_url === image.src).id
    })
    if (!this.contents.padding) this.contents.padding = {y: 0}
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import './CarouselStandard1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './CarouselStandard1.s.scss';
}
.tablet,
.desktop {
  @import './CarouselStandard1.m.scss';
}
.desktop {
  @import './CarouselStandard1.l.scss';
}

.image-select {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  padding: 10px 0;
  height: 300px;
  overflow: scroll;
  &-item {
    width: 156px;
    height: 156px;
  }
  &-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &-input {
    display: none;
    &:checked ~ .image-select-label:after {
      border: 3px solid $--color-danger;
    }
  }
  &-label {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents/CarouselStandard1/CarouselStandard1.vue